var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgECommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    fill: "#00AEFF",
    fillOpacity: 0.15,
    stroke: "#00AEFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0625 41.125V48.875H40.3125V41.125H48.0625ZM48.0625 60.5V52.75H40.3125V60.5H48.0625ZM59.6875 41.125V48.875H51.9375V41.125H59.6875ZM59.6875 60.5V52.75H51.9375V60.5H59.6875ZM38.375 33.375V27.5625C38.375 26.0209 38.9874 24.5425 40.0774 23.4524C41.1675 22.3624 42.6459 21.75 44.1875 21.75H55.8125C57.3541 21.75 58.8325 22.3624 59.9226 23.4524C61.0126 24.5425 61.625 26.0209 61.625 27.5625V33.375H71.3125C71.8264 33.375 72.3192 33.5791 72.6825 33.9425C73.0459 34.3058 73.25 34.7986 73.25 35.3125V60.5C73.25 62.5554 72.4335 64.5267 70.9801 65.9801C69.5267 67.4335 67.5554 68.25 65.5 68.25H34.5C32.4446 68.25 30.4733 67.4335 29.0199 65.9801C27.5665 64.5267 26.75 62.5554 26.75 60.5V35.3125C26.75 34.7986 26.9541 34.3058 27.3175 33.9425C27.6808 33.5791 28.1736 33.375 28.6875 33.375H38.375ZM42.25 27.5625V33.375H57.75V27.5625C57.75 27.0486 57.5459 26.5558 57.1825 26.1925C56.8192 25.8291 56.3264 25.625 55.8125 25.625H44.1875C43.6736 25.625 43.1808 25.8291 42.8175 26.1925C42.4541 26.5558 42.25 27.0486 42.25 27.5625ZM30.625 60.5C30.625 61.5277 31.0333 62.5133 31.76 63.24C32.4867 63.9667 33.4723 64.375 34.5 64.375H65.5C66.5277 64.375 67.5133 63.9667 68.24 63.24C68.9667 62.5133 69.375 61.5277 69.375 60.5V37.25H30.625V60.5Z",
    fill: "#00AEFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/e-commerce.9a52589c18309281368c9bda721998bf.svg";
export { ForwardRef as ReactComponent };